import { render } from "./yimai.vue?vue&type=template&id=c63c5d54"
import script from "./yimai.vue?vue&type=script&lang=js"
export * from "./yimai.vue?vue&type=script&lang=js"

import "./yimai.vue?vue&type=style&index=0&id=c63c5d54&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__